module.exports = __webpack_public_path__ + "img/offline_WiFi.44ce8686.svg";